<!-- Text message -->
@if (message.role === 'user' || message.role === 'assistant') {
    <div
        class="max-w-[80%] rounded-2xl px-3 py-2 text-sm shadow-sm"
        [ngClass]="{
            'self-end bg-blue-500 text-white': message.role === 'assistant',
            'self-start border border-slate-200 bg-white text-slate-900':
                message.role === 'user',
        }"
    >
        <div
            class="prose prose-sm max-w-none"
            [ngClass]="{
                'prose-invert': message.role === 'assistant',
            }"
            [innerHtml]="message.text | marked | safeHtml"
        ></div>
    </div>
}

<!-- Tool message -->
@if (message.role === 'tool') {
    <div
        class="flex items-center gap-2 self-center rounded-full border px-3 py-1 text-[0.7rem] font-medium"
        [ngClass]="{
            'border-amber-200 bg-amber-50 text-amber-700':
                message.status === 'pending',
            'border-emerald-200 bg-emerald-50 text-emerald-700':
                message.status === 'success',
            'border-rose-200 bg-rose-50 text-rose-700':
                message.status === 'failure',
        }"
    >
        @if (message.status === 'pending') {
            <app-loading-ring />
        } @else {
            <i
                class="fa"
                [ngClass]="{
                    'fa-check text-emerald-500': message.status === 'success',
                    'fa-times text-rose-500': message.status === 'failure',
                }"
            ></i>
        }
        <span>
            {{ 'translate_tool_call' | translate }} -
            {{ message.toolName | translateToolName | translate }}
        </span>
    </div>
}
